import { styled } from 'styletron-react'
import { padding } from 'lostyle'
import { media, sizes } from '../../style'

export const Wrapper = styled('div', (props) => ({
  ...padding({
    top: '50px',
    bottom: sizes.spacing.gutter.mobile
  }),
  // ...media('tablet', {
  //   ...padding({
  //     // y: '40px'
  //   })
  // })
}))
Wrapper.displayName = 'Layout.Wrapper'



// WEBPACK FOOTER //
// ./src/common/Layout/styles.js